<script setup>
import { computed } from 'vue';
import VariablePicker from './VariablePicker.vue';

const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  type: { type: String, default: 'input' },
  rows: { type: [Number, String], default: 3 },
  inputClass: { type: String, default: '' },
  mono: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue', 'change']);

const value = computed({
  get: () => props.modelValue || '',
  set: v => {
    emit('update:modelValue', v);
    emit('change');
  },
});

const onPickerInsert = newVal => {
  value.value = newVal;
};
</script>

<template>
  <div class="vi-wrap">
    <textarea
      v-if="type === 'textarea'"
      v-model="value"
      :rows="rows"
      :placeholder="placeholder"
      :class="['vi-textarea', inputClass, { 'font-mono text-xs': mono }]"
    />
    <input
      v-else
      v-model="value"
      type="text"
      :placeholder="placeholder"
      :class="['vi-input', inputClass, { 'font-mono text-xs': mono }]"
    />
    <VariablePicker
      :model-value="value"
      class="vi-picker"
      @update:model-value="onPickerInsert"
      @change="emit('change')"
    />
  </div>
</template>

<style scoped>
.vi-wrap {
  position: relative;
  width: 100%;
}

.vi-input {
  width: 100%;
  height: 2.5rem;
  padding: 0.5rem 2.5rem 0.5rem 0.75rem;
  font-size: 0.875rem;
  color: hsl(222 84% 5%);
  background: white;
  border: 1px solid hsl(210 11% 86%);
  border-radius: 0.375rem;
  outline: none;
  transition: border-color 0.15s ease;
}
.vi-input:focus {
  border-color: #3385ff;
}
.vi-input::placeholder {
  color: hsl(215 16% 47%);
}

.vi-textarea {
  width: 100%;
  padding: 0.625rem 0.75rem;
  padding-bottom: 2rem;
  font-size: 0.875rem;
  color: hsl(222 84% 5%);
  background: white;
  border: 1px solid hsl(210 11% 86%);
  border-radius: 0.375rem;
  outline: none;
  transition: border-color 0.15s ease;
  resize: vertical;
}
.vi-textarea:focus {
  border-color: #3385ff;
}
.vi-textarea::placeholder {
  color: hsl(215 16% 47%);
}

.vi-picker {
  position: absolute;
  bottom: 4px;
  right: 4px;
}
</style>
